<template lang="pug">
b-form-group( :label="label" label-cols="4" label-align="right" )
  b-form-input( :value="textValue" :list="id" :state="validValue" :disabled="disabled" size="sm" autocomplete="off" @input="input")
  b-form-datalist( :id="id" :options="mappedOptions" )
</template>

<script>
export default {
  props: ['value', 'label', 'options', 'valueField', 'textField', 'valid', 'disabled'],

  computed: {
    id() {
      return 'input_list_' + Date.now()
    },

    textValue() {
      let foundedOption = this.options.find(el => el[this.valueField] == this.value)
      return foundedOption ? foundedOption[this.textField] : this.value
    },

    mappedOptions() {
      return this.options.map(a => a[this.textField])
    },

    validValue(){
      return this.valid && this.options.find(el => el[this.valueField] == this.value) ? true : false
    },
  },

  methods: {
    input(text) {
      let foundedOption = this.options.find(el => el[this.textField].toLowerCase() == text.toLowerCase())
      let newValue = foundedOption ? foundedOption[this.valueField] : text
      this.$emit('input', newValue)
    },
  }
}
</script>